export const ITEM_TYPE_LABELS = {
  0: 'Arma',
  1: 'Kit',
  2: 'Municion',
  3: 'Objeto',
  4: 'Componente',
  5: 'Mision',
  6: 'Recurso',
  7: 'Especial',
  8: 'Motor',
  9: 'Radar',
  10: 'Mochila',
  11: 'Guerra electronica',
  12: 'Bateria'
};

export const ACCESSORY_ITEM_TYPES = {
  radar: 9,
  backpack: 10,
  ewar: 11,
  battery: 12
};

export const ACCESSORY_SLOTS = [
  {
    key: 'radar',
    label: 'Radar',
    type: ACCESSORY_ITEM_TYPES.radar,
    description: 'Detecta enemigos, objetos y enterrados segun el modelo.',
    details: 'El radar es el sensor principal del bot. Segun el modelo puede detectar enemigos cercanos, objetos visibles y objetos enterrados.',
    usage: 'Se equipa desde el hangar. Al activarlo, el mapa y la deteccion de recogida usan su alcance y sus capacidades.',
    statLabel: 'Potencia de barrido'
  },
  {
    key: 'backpack',
    label: 'Mochila',
    type: ACCESSORY_ITEM_TYPES.backpack,
    description: 'Aumenta la carga util del bot y define cuanto puedes llevar.',
    details: 'La mochila marca la capacidad real de carga del bot. No amplía la velocidad ni la deteccion, solo el espacio util para transportar objetos.',
    usage: 'Se equipa desde el hangar. Si no esta activa, el bot no puede salir a desplegarse ni recoger objetos del mapa.',
    statLabel: 'Capacidad'
  },
  {
    key: 'battery',
    label: 'Bateria',
    type: ACCESSORY_ITEM_TYPES.battery,
    description: 'Regula la velocidad de desplazamiento y la autonomia de paso.',
    details: 'La bateria alimenta el movimiento del bot. Su modelo influye en la velocidad de paso y en la autonomia del desplazamiento.',
    usage: 'Se equipa desde el hangar. Debe estar activa para poder desplegar el bot y moverse con normalidad.',
    statLabel: 'Autonomia'
  },
  {
    key: 'ewar',
    label: 'Guerra electronica',
    type: ACCESSORY_ITEM_TYPES.ewar,
    description: 'Emite interferencias para infiltracion, sabotaje y acceso especial.',
    details: 'La guerra electronica abre opciones tacticas avanzadas. Puede anular minas, interferir enemigos y permitir entrada a ciudades enemigas segun el modelo.',
    usage: 'Se equipa desde el hangar. Activa sus efectos en cuanto el bot la lleva montada y encendida.',
    statLabel: 'Interferencia'
  }
];

export const HANGAR_MODEL_CATALOG = {
  backpack: [
    {
      name: 'Mochila de Campo M-20',
      level: 1,
      price: 180,
      power: 30,
      quality: 'Ligera',
      qualities: ['Muy ligera', 'Ideal para rutas cortas']
    },
    {
      name: 'Mochila Tactica R-45',
      level: 3,
      price: 450,
      power: 55,
      quality: 'Tactica',
      qualities: ['Equilibrada', 'Buena para exploracion']
    },
    {
      name: 'Mochila Blindada Aegis',
      level: 6,
      price: 980,
      power: 85,
      quality: 'Blindada',
      qualities: ['Alta capacidad', 'Mas peso, menos movilidad']
    },
    {
      name: 'Mochila Logistica Titan',
      level: 9,
      price: 1800,
      power: 120,
      quality: 'Industrial',
      qualities: ['Carga pesada', 'Perfecta para mineria y saqueo']
    },
    {
      name: 'Mochila ExoCarrier X-01',
      level: 12,
      price: 3200,
      power: 170,
      quality: 'Premium',
      qualities: ['Maxima capacidad', 'Pensada para pilotos avanzados']
    }
  ],
  battery: [
    {
      name: 'Celda Estable S1',
      level: 1,
      price: 140,
      power: 10,
      quality: 'Estable',
      qualities: ['Movimiento base', 'Consumo reducido']
    },
    {
      name: 'Bateria Ion-Litio B2',
      level: 3,
      price: 420,
      power: 20,
      quality: 'Rapida',
      qualities: ['Mejor respuesta', 'Menor retardo']
    },
    {
      name: 'Bateria de Pulso P4',
      level: 6,
      price: 900,
      power: 32,
      quality: 'Pulso',
      qualities: ['Acelera los pasos', 'Buen equilibrio general']
    },
    {
      name: 'Bateria Nuclear Compacta N7',
      level: 9,
      price: 1700,
      power: 45,
      quality: 'Compacta',
      qualities: ['Muy alta autonomia', 'Movimiento mas rapido']
    },
    {
      name: 'Core de Flujo Omega',
      level: 12,
      price: 3200,
      power: 60,
      quality: 'Elite',
      qualities: ['Maximo rendimiento', 'Pensada para maratones de exploracion']
    }
  ],
  ewar: [
    {
      name: 'Emisor de Ruido Nulo',
      level: 2,
      price: 260,
      power: 1,
      quality: 'Basico',
      qualities: ['Suprime firmas simples', 'Abre el acceso a infiltracion ligera', 'Bajo consumo']
    },
    {
      name: 'Transmisor Delta-3',
      level: 4,
      price: 620,
      power: 2,
      quality: 'Tactico',
      qualities: ['Anula minas basicas', 'Interfiere con deteccion enemiga', 'Mayor control perimetral']
    },
    {
      name: 'Jammer Kappa',
      level: 7,
      price: 1250,
      power: 3,
      quality: 'Avanzado',
      qualities: ['Penetra ciudades de clan', 'Reduce bloqueo enemigo', 'Cobertura ampliada']
    },
    {
      name: 'Matriz Sigma Blackout',
      level: 10,
      price: 2600,
      power: 4,
      quality: 'Elite',
      qualities: ['Interferencia total', 'Sabotaje y ocultacion avanzada', 'Modo blackout']
    }
  ],
  radar: [
    {
      name: 'Radar de Barrido R-1',
      level: 1,
      price: 220,
      power: 20,
      quality: 'Basico',
      qualities: ['Detecta enemigos cercanos', 'No detecta enterrados']
    },
    {
      name: 'Radar Tactico R-2',
      level: 3,
      price: 540,
      power: 40,
      quality: 'Tactico',
      qualities: ['Detecta enemigos y objetos', 'Cobertura amplia']
    },
    {
      name: 'Radar Profundidad D-4',
      level: 5,
      price: 1100,
      power: 60,
      quality: 'Profundo',
      qualities: ['Detecta enterrados', 'Muy util para excavacion']
    },
    {
      name: 'Radar Omega MX',
      level: 8,
      price: 2400,
      power: 90,
      quality: 'Avanzado',
      qualities: ['Detecta todo tipo de señales', 'Incluye minas y enterrados']
    }
  ]
};

export function normalizeAccessorySource(item) {
  return {
    ...item,
    item_type: Number(item?.item_type || 0),
    power: Number(item?.power || 0),
    weight: Number(item?.weight || 0),
    level_required: Number(item?.level_required || 0)
  };
}

export function getBackpackCapacityFromPower(power) {
  const rawPower = Number(power || 0);
  const capacity = Math.round(rawPower / 2);
  if (!Number.isFinite(capacity) || capacity <= 0) return 15;
  return Math.max(15, Math.min(50, capacity));
}

export function getAccessorySource(items = [], itemType) {
  const list = items
    .filter((item) => Number(item?.item_type || -1) === Number(itemType))
    .map(normalizeAccessorySource)
    .sort((a, b) => Number(b.power || 0) - Number(a.power || 0));

  return list.find((item) => Number(item?.equipped || 0) === 1) || list[0] || null;
}

export function getBackpackCapacity(source) {
  if (!source) return 15;
  return getBackpackCapacityFromPower(source.power || source?.metadata?.capacity || source?.metadata?.backpack_capacity || 0);
}

export function getBatteryMoveTickMs(source) {
  if (!source) return 180;
  const speedBonus = Number(source.power || source?.metadata?.speed_bonus || 0);
  return Math.max(90, 180 - Math.min(90, speedBonus * 3));
}

export function getElectronicWarfareCapabilities(source) {
  const metadata = source?.metadata || {};
  const strength = Number(source?.power || source?.metadata?.strength || 0);
  return {
    hasModule: Boolean(source),
    strength,
    canBypassForeignCities: metadata.city_bypass === true || metadata.city_bypass === 1,
    canJamMines: metadata.mine_jam === true || metadata.mine_jam === 1,
    canDisruptEnemies: metadata.enemy_jam === true || metadata.enemy_jam === 1
  };
}

export function getElectronicWarfareProfile(source) {
  const capabilities = getElectronicWarfareCapabilities(source);
  const model = HANGAR_MODEL_CATALOG.ewar.find((item) => item.name === source?.name) || null;
  const metadata = source?.metadata || {};
  const qualities = model?.qualities || [];

  return {
    name: source?.name || model?.name || 'Modulo de guerra electronica',
    description: source?.description || 'Modulo de guerra electronica',
    quality: model?.quality || 'Basico',
    level: Number(source?.level_required || model?.level || 0),
    power: Number(source?.power || model?.power || 0),
    price: Number(model?.price || source?.value || 0),
    qualities,
    metadata,
    capabilities
  };
}
